function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 283.5h283.5l-99.3-134.9v-99h28.4V21.3H70.9v28.3h28.3v99L0 283.5zM155.8 49.6v99c0 6.1 1.9 12 5.6 16.9l65.7 89.4H56.4l65.8-89.4c3.6-4.9 5.6-10.8 5.6-16.9v-99h28z"
})));